import AuthState from '@/models/auth/auth-state.model';
import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { state } from "./state";

const user: Module<AuthState, {}> = {
    actions,
    state,
    mutations,
    getters,
    namespaced: true
};

export default user;

